import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SportCode from 'components/common/SportCode';
import { DIR_MEDIA_TYPE, SCREEN_TYPE, getFullPath, usePathFlag, usePathPhoto } from 'helpers/utils';
import Label from "components/general/Label"
import { useUrlFriendlyToParameters, useGetURL } from "helpers/urlFriendly";
import { useAbsoluteRoot } from 'helpers/urlRoot';
import { useGetNocs } from 'helpers/commonCodes';
import { useViewport } from 'components/general/useViewPort';
import { LazyLoadImage } from 'react-lazy-load-image-component';



const Captain = () => {

	return (
		<Label data="LabelCaptain" tooltip={true} />
	)
}


const CompetitorLink = (props) => {
	const competitorCode = props?.code;
	let params = useUrlFriendlyToParameters();
	const getURL = useGetURL()
	const { breakPoint } = useViewport();

	params["mirs_code"] = competitorCode;
	let page = "";
	let typer = props?.__typename;
	let cat = props?.mainFunction?.category;
	if (typer !== null) {
		if (typer === "Team") {
			page = "team";
		} else if (typer === "Horse") {
			page = "horse";
		} else if (cat !== null) {
			if (cat === "A")
				page = "bios";
			else if (cat === "C")
				page = "coach";
			else if (cat === "J")
				page = "official";
		}
	}

	const url = getURL(params, page)
	let component;

	if (props.noLink || page === "") {
		component = <div className='competitor-container'> {CompetitorBox(props)} </div>
	} else {
		component = <Link data-ocs-event={`${props?.code}`} to={url} className='competitor-container'> {CompetitorBox(props)} </Link>
	}


	//Guide
	let guideName = ""
	if (props.onlyShortName) {
		guideName = props?.guide?.shortName
	} else {
		if (breakPoint === "xs") {
			guideName = props?.guide?.shortName
		} else {
			guideName = props?.guide?.name
		}
	}

	return (
		<>
			{component}
			{props?.showGuide && props?.guide && <div className='small'>{props?.guide?.mainFunction?.description}:&nbsp;{guideName}</div>}
		</>
	)
}


const CompetitorBox = (props) => {
	const { breakPoint } = useViewport();
	const isMobile = (breakPoint === "sm" || breakPoint === "xs");
	const { mirs_discipline } = useUrlFriendlyToParameters()
	let params = useUrlFriendlyToParameters();
	const nocList = useGetNocs(params)
	const codePhoto = usePathPhoto()
	const [showImage, setShowImage] = useState(true);
	const [showNocImage, setShowNocImage] = useState(true);
	const codeNoc = usePathFlag(props?.organisation?.code || props?.organisationId)

	useEffect(() => {
		setShowNocImage(true);
	}, [props?.code]);


	const isRibbon = props?.screen === SCREEN_TYPE.RIBBON
	const onlyShortName = isRibbon || props?.onlyShortName
	const captain = props?.eventUnitEntries?.find(eue => eue.eue_code === 'CAPTAIN') ? <Captain /> : ''
	//const captainAbbr = props?.eventUnitEntries?.find(eue => eue.eue_code === 'CAPTAIN') ? <CaptainAbbr /> : ''
	//const disciplineClass = props?.disciplineClass?.classCode ? props?.disciplineClass?.classCode : ''  //deprecated for using abbr
	let starter = props?.eventUnitEntries?.find(eue => eue.eue_code === 'STARTER' && eue.eue_value === 'Y') ? '*' : ''
	let substitute = props?.eventUnitEntries?.find(eue => eue.eue_code === 'SUBSTITUTE' && eue.eue_value === 'S') ? '(S)' : ''
	let suspendedCode = props?.eventUnitEntries?.find(eue => eue.eue_code === 'STATUS')?.eue_value;
	suspendedCode = params.mirs_discipline === 'BKB' ? (<SportCode discipline='BKB' entity='@AthleteStatus' code={suspendedCode} />) : suspendedCode

	let d_block_d_md_none = props.alwaysNoc ? "" : "d-block d-md-none";
	let competitor_country_flag_container = props.alwaysNoc ? 'competitor-country-flag-container-always-noc' : 'competitor-country-flag-container';
	let d_flex_flex_row = props.alwaysNoc ? ' d-flex flex-row' : ''


	const hideImg = () => {
		setShowImage(false);
	};

	const hideNocImg = (event) => {
		setShowNocImage(false);
	};

	const competitorCode = props?.code;
	const url = (showImage && props?.image) ? getFullPath(competitorCode, DIR_MEDIA_TYPE.THUMBS, props?.image?.imageExtension) : codePhoto;
	const name = (props?.teamType === 'ORG' && props?.organisation?.longDescription) ? props?.organisation?.longDescription : props?.name;
	const shortName = (props?.teamType === 'ORG' && props?.organisation?.description) ? props?.organisation?.description : props?.shortName;
	const unchecked = props.unchecked
	let noc = props?.organisation?.code || props?.organisationId;
	let nocDesc = props?.organisation?.longDescription || props?.organisation?.description;
	if (!nocDesc) {
		const nocObject = nocList?.nocs?.find(n => n?.code === noc);
		nocDesc = nocObject?.longDescription
	}
	const alignEnd = props?.alignEnd ? ' align-end' : '';
	const hideNoc = props?.hideNoc === undefined ? false : props?.hideNoc;
	const hideNocName = props?.hideNocName === undefined ? false : props?.hideNocName;
	let hideMedicalClassDiscipline = ['WTE']
	let medicalClass = props?.__typename === 'Person' && props?.medicalClass?.classCode && '(' + props?.medicalClass?.classCode + ')'
	let showMedicalClass = ((props?.showMedicalClass === undefined || props?.showMedicalClass === true)) ? true : false;

	showMedicalClass = hideMedicalClassDiscipline.includes(mirs_discipline) ? false : true
	medicalClass = showMedicalClass && medicalClass
	let extradata = props.showCaptain ? captain : undefined
	extradata = props.showSuspendedCode ? <>{extradata} {suspendedCode}</> : extradata
	extradata = props.showSubstitute ? <>{extradata} {substitute}</> : extradata
	extradata = props.showSeed && props?.seed !== undefined ? <>{extradata} <sup>{'(' + props.seed + ')'}</sup></> : extradata
	extradata = medicalClass
		? <>
			{extradata}<span>({props?.medicalClass?.classCode})</span> {/* (<abbr title={props?.medicalClass?.description}>{props?.medicalClass?.classCode}</abbr>) */}
		</>
		: <>{extradata}</>

	const hasExtradata = extradata?.props?.children

	params["mirs_code"] = competitorCode;

	let clientClass = `ath-${competitorCode}`;
	let typeCopmetitor = props?.__typename;
	let cat = props?.mainFunction?.category;
	if (typeCopmetitor !== null) {
		if (typeCopmetitor === "Team") {
			clientClass = `team-${competitorCode}`;
		} else if (typeCopmetitor === "Horse") {
			clientClass = `horse-${competitorCode}`;
		}
		else if (cat !== null) {
			if (cat === "A")
				clientClass = `ath-${competitorCode}`;
			else if (cat === "C")
				clientClass = `coach-${competitorCode}`;
			else if (cat === "J")
				clientClass = `official-${competitorCode}`;
		}
	}


	const nocAbbr = (isMobile || hideNocName)
		? <span>{noc}</span>
		: <abbr className='me-1' title={nocDesc} aria-hidden="true">{noc}</abbr>




	const imgAlt = (props?.teamType === 'ORG') ? '' : nocDesc;


	// props?.noTruncate has been introduced due to the issue where text-wrap functionality is compromised by text-truncate, as seen in scenarios like TEN play by play in responsive mode.
	return (
		<>
			{props.showStarter ? <div className='w-5'>{starter}</div> : ''}
			{
				!props.hidePicture &&
				<div className='competitor-image-container d-sm-block' >
					<div className='competitor-image' >
						<picture>
							<LazyLoadImage
								className={`object-fit-cover-picture-img`}
								alt=""
								effect="blur"
								src={url}
								height={process.env.REACT_APP_ATHLETE_THUMB_IMG_HEIGHT}
								width={process.env.REACT_APP_ATHLETE_THUMB_IMG_WIDTH}
							/>
						</picture>
					</div>
				</div>
			}

			<div className={`competitor-name${alignEnd}${d_flex_flex_row} ${clientClass}`}>
				{
					!hideNoc && (
						<div className={`competitor-country my-auto ${d_block_d_md_none}`}>
							<div className='competitor-country-container'>
								<div className={competitor_country_flag_container}>
									{showNocImage ? (
										<LazyLoadImage
											className='competitor-country-flag'
											alt={imgAlt}
											src={codeNoc}
											height={process.env.REACT_APP_NOC_IMG_HEIGHT}
											width={process.env.REACT_APP_NOC_IMG_WIDTH}
											onError={hideNocImg} />
									) : ('')}
								</div>
								{nocAbbr}
							</div>
						</div>)
				}
				{onlyShortName ? (
					<span className='competitor-short-name d-inline-block text-truncate' style={{ maxWidth: "100%" }}>{shortName} {extradata}</span>
				) : (
					<>
						<span className={`competitor-long-name d-none ${extradata !== undefined ? 'd-sm-inline-block' : 'd-sm-block'} text-truncate`}>
							{unchecked ? name + '*' : props?.noName ? '' : name} {extradata}
						</span>
						<span className={`competitor-short-name d-inline-block d-sm-none ${(hasExtradata && props?.noWrap) ? 'text-nowrap' : ''}`}>
							<span className={`${!props?.noTruncate && !isMobile ? 'text-truncate' : ''}`} >{unchecked ? shortName + '*' : props?.noName ? '' : shortName} </span>
							<span>{extradata}</span>
						</span>
					</>
				)}
			</div >
		</>
		//</React.Fragment>
	)
}


export const Competitor = React.memo((props) => {
	let athlete;
	//teamAthletes: pinta una lista con todos los atletas del equipo.
	if (props.teamAthletes) {
		const noSubstitute = athlete = props.teamAthletes?.filter(row => {
			if (!row?.eventUnitEntries || row?.eventUnitEntries?.some(ath => ath.eue_code !== 'SUBSTITUTE')) {
				return row
			}
		})

		athlete = noSubstitute?.sort((a, b) => a.order - b.order).map((item, key) => {
			let p = Object.assign({}, props, item?.athlete ? item?.athlete : item?.participant);
			return (<CompetitorLink {...p} key={key} />)
		})
	} else {
		athlete = CompetitorLink(props)
	}

	return (<>{athlete}</>)
});



// NOT IN USE
export const Competitor2Lines = React.memo(({ familyName, givenName, noc, code, hidePicture, showCaptain, showSuspendedCode, showStarter, props, alwaysNoc }) => {
	let params = useUrlFriendlyToParameters();
	const getURL = useGetURL()
	let captain = props?.eventUnitEntries?.find(eue => eue.eue_code === 'CAPTAIN') ? '(Captain)' : ''
	let starter = props?.eventUnitEntries?.find(eue => eue.eue_code === 'STARTER' && eue.eue_value === 'Y') ? '*' : ''
	let suspendedCode = props?.eventUnitEntries?.find(eue => eue.eue_code === 'STATUS')?.eue_value;
	suspendedCode = (<SportCode discipline='BKB' entity='@AthleteStatus' code={suspendedCode} />)
	let d_block_d_sm_none = alwaysNoc ? "" : "d-block d-sm-none";
	let competitor_country_flag_container = alwaysNoc ? 'competitor-country-flag-container-always-noc' : 'competitor-country-flag-container';
	let hideNoc = props?.hideNoc === undefined ? false : props?.hideNoc;

	const codeNoc = usePathFlag(noc)
	const codePhoto = usePathPhoto()

	params["mirs_code"] = code;
	const url = getURL(params, 'bios')
	return (

		//<React.Fragment key={code + "_competitor"}>

		<Link to={url} className='competitor-container'>
			{showStarter ? <div className='w-5'>{starter}</div> : ''}
			{
				!hidePicture &&
				<div className='competitor-image-container d-none d-sm-block' >
					<div className='competitor-image' >

						<picture>
							<LazyLoadImage
								className='object-fit-cover-picture-img'
								alt={familyName}
								src={codePhoto}
							/>
						</picture>
					</div>
				</div>
			}

			<div className='competitor-name'>
				{!hideNoc && (
					<span className={`competitor-country  ${d_block_d_sm_none}`}>
						<div className='competitor-country-container'>
							<div className={competitor_country_flag_container}>
								<LazyLoadImage
									className='competitor-country-flag'
									alt=""
									src={codeNoc}
									height={process.env.REACT_APP_NOC_IMG_HEIGHT}
									width={process.env.REACT_APP_NOC_IMG_WIDTH} />
							</div>
							{noc}
						</div>
					</span>
				)}
				<span className='competitor-first'> {givenName} </span>
				<span className='competitor-last'> {familyName} </span>

			</div>
			{showCaptain ? <div>{captain}</div> : ''}
			{showSuspendedCode ? <div>{suspendedCode}</div> : ''}

		</Link>
		//</React.Fragment>
	)
});




export default Competitor


